import { render, staticRenderFns } from "./UnitManage.vue?vue&type=template&id=2d5a4f9c&scoped=true"
import script from "./UnitManage.vue?vue&type=script&lang=js"
export * from "./UnitManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5a4f9c",
  null
  
)

export default component.exports